var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97837 7.1756L9.36501 2.95574C10.1407 2.34809 11.2268 2.34809 12.0025 2.95574L17.3892 7.1756C18.004 7.65731 18.1749 8.37427 18.1834 9.20295C18.1839 9.24787 18.1824 9.29129 18.179 9.33608C18.1442 9.7957 17.9033 12.6041 17.0128 15.757C16.6982 16.6346 15.9578 17.5 14.9393 17.5H6.42822C5.40968 17.5 4.66934 16.6346 4.35468 15.757C3.46429 12.6041 3.22334 9.79569 3.18849 9.33608C3.1851 9.29129 3.18364 9.24787 3.18411 9.20295C3.19266 8.37427 3.36347 7.65731 3.97837 7.1756Z",
    stroke: "#D4DADD",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAlt);
export default __webpack_public_path__ + "static/media/home-alt.9aa0c0d25c2cfec6e05ba4401f381a0e.svg";
export { ForwardRef as ReactComponent };